import create from 'zustand';
import createStoreSelectors from '../utils/createStoreSelector';

const useStore = create((set) => ({
  isGroupInvitationReceived: false,
  toggleGroupInvitationReceived: (value) => {
    set((state) => ({
      ...state,
      isGroupInvitationReceived: value
    }));
  }
}));

const useGroupsInvitationStore = createStoreSelectors(useStore);

export default useGroupsInvitationStore;
